import type { PluginManifest, PluginRegistry } from "./types"
import { chatPlugin } from "./chat/manifest"
import { gradeAIPlugin } from "./gradeai/manifest"
import { sortPlugins } from "./utils"

const registry: PluginRegistry = sortPlugins([
  chatPlugin,
  gradeAIPlugin,
])

export function getAllPlugins(): PluginManifest[] {
  return registry
}

export function getEnabledPlugins(): PluginManifest[] {
  return registry.filter((plugin) => plugin.availability === "enabled")
}

export function getPluginById(id: string): PluginManifest | undefined {
  return registry.find((plugin) => plugin.id === id)
}

export default registry
